import { render } from "./CreateOptions.vue?vue&type=template&id=9a76abb8&scoped=true"
import script from "./CreateOptions.vue?vue&type=script&lang=js"
export * from "./CreateOptions.vue?vue&type=script&lang=js"

import "./CreateOptions.vue?vue&type=style&index=0&id=9a76abb8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a76abb8"]])

export default __exports__